import axios from "axios";
import apiService from "./apiService";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/chat`;

export const deleteChatService = async (getToken, chatId) => {
  try {
    const token = await getToken();
    const response = await axios.delete(`${API_BASE_URL}/delete_chat`, {
      chatId,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting task:", error);
    throw error;
  }
};

export const getChatsByProjectAndTaskIdsService = async (
  getToken,
  { projectIds, taskIds }
) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/get_chats_by_project_and_task_ids`,
      { projectIds, taskIds },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error getting chats by project and task ids:", error);
    throw error;
  }
};

export const getChatsByEmailIdsService = async (getToken, emailIds) => {
  try {
    const token = await getToken();
    const response = await axios.post(`${API_BASE_URL}/get_chats_by_email_ids`, { emailIds }, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting chats by email ids:", error);
    throw error;
  }
};

export const getEmailThreadService = async (getToken, params) => {
  try {
    const token = await getToken();

    const response = await fetch(
      `${API_BASE_URL}/get_or_create_email_thread?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
  return response;
  } catch (error) {
    console.error("Error getting email thread:", error);
    throw error;
  }
};

export const getTaskThreadService = async (getToken, params) => {
  try {
    const token = await getToken();

    const response = await axios.get(
      `${API_BASE_URL}/get_chat_by_thread_id?chatId=${params.chatId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error getting task thread:", error);
    throw error;
  }
};

export const setChatMessageFeedbackService = async ({
  messageId,
  chatId,
  feedbackType,
  reason,
}) => {
  try {
    const response = await apiService.post(`${API_BASE_URL}/set_chat_message_feedback`,
      { messageId, chatId, feedbackType, reason }
    );
    return response;
  } catch (error) {
    console.error("Error setting chat feedback:", error);
    throw error;
  }
};
